module.exports = __webpack_public_path__ + "media/images/soar/site/icons/icon_3-4796bda8c850608fef58b58ad6568f0b.svg";